module.exports = __webpack_public_path__ + "static/media/l12_voice_six_v2.8fb6ba60.mp3";